import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { LanguageSuggestion } from "./LanguageSuggestion";
import { CookieConsent } from "./CookieConsent";
import { CallbackDrawer } from "./CallbackDrawer";
import { useSettings } from "../context/SettingsContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

const WhatsAppFloat = () => {
  const { settings } = useSettings();
  const num = (settings.whatsapp || "").replace(/[^0-9]/g, "");
  if (!num) return null;
  return (
    <a
      href={`https://wa.me/${num}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 start-6 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </a>
  );
};

export const Layout = ({ children }) => (
  <div className="App bg-white">
    <ScrollToTop />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppFloat />
    <CallbackDrawer />
    <CookieConsent />
    <LanguageSuggestion />
  </div>
);
